import { ModalsManager } from '@/components/modals/modalsManager';
import { getBundledMcpTemplate } from '@/features/integrations/bundled-mcp-templates';
import { onDeviceMcpCatalogQueryOptions } from '@/features/integrations/integrations.query';
import { LocalMcpAddServerModal } from '@/features/local-mcp';
import { connectAppleNativeToolkit } from '@/integrations/apple-native-connect';
import {
  trackOnDeviceConnectClicked,
  type OnDeviceSurface,
} from '@/integrations/integrations.utils';
import { logger } from '@/lib/logger';
import { queryClient } from '@/query/client';

export async function openOnDeviceSetup(
  id: string,
  displayName: string,
  surface: OnDeviceSurface
): Promise<void> {
  const bundledTemplate = getBundledMcpTemplate(id);
  if (bundledTemplate) {
    trackOnDeviceConnectClicked(id, 'bundled', surface);
    ModalsManager.show(LocalMcpAddServerModal, { bundledTemplate });
    return;
  }
  if (id === 'applereminders' || id === 'applecontacts') {
    await connectAppleNativeToolkit(id, displayName, surface);
    return;
  }
  const catalog = await queryClient.fetchQuery(
    onDeviceMcpCatalogQueryOptions()
  );
  const catalogEntry = catalog.find((entry) => entry.id === id);
  if (catalogEntry) {
    trackOnDeviceConnectClicked(id, 'catalog', surface);
    ModalsManager.show(LocalMcpAddServerModal, { catalogEntry });
    return;
  }
  logger.warn('No on-device setup for integration suggestion', { id });
}
